module.exports = __webpack_public_path__ + "img/pager2-quick-icon10.a3436461.png";